import {
  UNSPLASH_API_BASE_URL,
  UNSPLASH_AUTH_HEADER,
} from "../constants/imageServices";
import { fetch } from "./base";

export const fetchUnsplashCollections = async () => {
  return fetch(UNSPLASH_API_BASE_URL + "/collections?per_page=50", {
    cache: true,
    thirdParty: true,
    headers: UNSPLASH_AUTH_HEADER,
  });
};

export const fetchUnsplashPhotos = async (
  search = "nature",
  page = 1,
  orientation = "landscape"
) => {
  return fetch(
    `${
      UNSPLASH_API_BASE_URL +
      "/search/photos/" +
      `?query=${
        search || "nature"
      }&page=${page}&per_page=${30}&orientation=${orientation}`
    }`,
    { cache: true, thirdParty: true, headers: UNSPLASH_AUTH_HEADER }
  );
};
